import React from 'react'
// Styles
import styles from './Categories.module.scss'
// Config
import { VISIBLE_ALBUM_CATEGORIES, ALL_CATEGORY_ID, albumsConfig } from 'config/albums.config'

// 相册分类导航。刻意不复用 Tab（视图切换）——两者是不同层级：
// 分类决定「看哪些照片」，视图只决定「怎么摆」。这里用圆角胶囊 + 高亮文字区分。
interface CategoriesProps {
  value: string
  onChange?: (category: string) => void
}

const Categories = ({ value, onChange }: CategoriesProps) => {
  // 用 VISIBLE_ALBUM_CATEGORIES 而不是 ALBUM_CATEGORIES：
  // 隐藏分类（图床位，如「隐藏」）不出现在导航上，只在 /admin 后台里可见。
  const items = [
    { id: ALL_CATEGORY_ID, name: albumsConfig.allLabel || '全部' },
    ...VISIBLE_ALBUM_CATEGORIES.map((category) => ({ id: category.id, name: category.name })),
  ]

  return (
    <nav className={styles.categories} aria-label="相册分类">
      {
        items.map((item) => {
          const active = value === item.id
          return (
            <button
              key={item.id}
              type="button"
              className={`${styles.item}${active ? ` ${styles.itemActive}` : ''}`}
              aria-current={active ? 'true' : undefined}
              onClick={() => onChange?.(item.id)}
            >
              {item.name}
            </button>
          )
        })
      }
    </nav>
  )
}

export default Categories
